module.exports = __webpack_public_path__ + "static/media/water2.da40d302.jpg";